import React from "react";

interface CustomTooltipTrackerProps {
  active?: boolean;
  payload?: readonly any[];
  setHoveredPoint: (point: any) => void;
}

export const CustomTooltipTracker: React.FC<CustomTooltipTrackerProps> = ({
  active,
  payload,
  setHoveredPoint,
}) => {
  React.useEffect(() => {
    if (active && payload && payload[0]) {
      setHoveredPoint(payload[0].payload);
    } else {
      setHoveredPoint(null);
    }
  }, [active, payload, setHoveredPoint]);

  return null; // Don't render anything
};
